import { useState, useEffect, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Overview from "../../img/Overview.svg";
import BrasilBand from "../../img/brasil.png";
import EUABand from "../../img/estados-unidos.png";
import EspanhaBand from "../../img/espanha.png";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import ModalVersao from "../../components/modalVersion";
import ModalLogout from "../../components/modalLogout";
import { useTranslation } from "react-i18next";
import IconToSolve from "../../components/icon";

function CustomNavbar() {
  const { t, i18n } = useTranslation();
  const [showModalVersion, setShowModalVersion] = useState(false);
  const handleShowModalVersion = () => setShowModalVersion(true);
  const handleCloseModalVersion = () => setShowModalVersion(false);
  const [showModalLogout, setShowModalLogout] = useState(false);
  const handleShowModalLogout = () => setShowModalLogout(true);
  const handleCloseModalLogout = () => setShowModalLogout(false);
  const [userInitials, setUserInitials] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false);
  const [menuOpenedByClick, setMenuOpenedByClick] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang) {
      setCurrentLang(storedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setCurrentLang(lang);
  };

  useEffect(() => {
    if (!showMenu) return;

    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowMenu(false);
        setShowLangMenu(false);
        setMenuOpenedByClick(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.user?.name;
    if (userName) {
      const [firstName, ...rest] = userName.trim().split(" ");
      const lastName = rest.length ? rest[rest.length - 1] : "";
      setUserInitials(
        lastName
          ? `${firstName[0]}${lastName[0]}`.toUpperCase()
          : firstName[0].toUpperCase(),
      );
    }
  }, []);

  return (
    <>
      <Navbar className="menu-top">
        <Container className="menu">
          <Link to="/">
            <img
              src={Overview}
              alt={"Overview "}
              className={`${"img-sidebar"}`}
              width="100%"
              height="100%"
            />
          </Link>
          <div className="d-inline-flex align-items-center">
            <div
              className="user-menu-container"
              ref={userMenuRef}
              onMouseEnter={() => setShowMenu(true)}
              onMouseLeave={() => {
                if (!menuOpenedByClick) setShowMenu(false);
              }}
            >
              <button
                title={t("Página de perfil")}
                className="user-initials btn-table img-user"
                onClick={() => {
                  if (!showMenu) {
                    setShowMenu(true);
                    setMenuOpenedByClick(true);
                  } else if (!menuOpenedByClick) {
                    // Se estava aberto por hover, ativa modo clique
                    setMenuOpenedByClick(true);
                  } else {
                    // Se já estava aberto por clique, fecha
                    setShowMenu(false);
                    setMenuOpenedByClick(false);
                  }
                }}
              >
                {userInitials}
              </button>

              {showMenu && (
                <div className="user-menu">
                  <Link to="/perfil" className="user-menu-item ">
                    {t("Perfil")}
                  </Link>

                  <div
                    className="lang-menu-container"
                    onMouseEnter={() => setShowLangMenu(true)}
                    onMouseLeave={() => setShowLangMenu(false)}
                  >
                    <button className="user-menu-item">{t("Idioma")}</button>

                    {showLangMenu && (
                      <div className="lang-menu">
                        <button
                          onClick={() => changeLanguage("pt-BR")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "pt-BR" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={BrasilBand}
                            alt="Português"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          Português
                        </button>
                        <button
                          onClick={() => changeLanguage("en")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "en" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={EUABand}
                            alt="English"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          English
                        </button>
                        <button
                          onClick={() => changeLanguage("es")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "es" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={EspanhaBand}
                            alt="Español"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          Español
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    className="user-menu-item"
                    style={{ color: "red" }}
                    onClick={handleShowModalLogout}
                  >
                    {t("Sair")}
                  </button>
                </div>
              )}
            </div>

            <button
              className="btn-table d-flex "
              onClick={handleShowModalVersion}
            >
              <IconToSolve iconName={"Interrogacao"} width={47} height={47} />
            </button>
            <Link
              title={t("Página de logs")}
              className="btn-table d-flex"
              to={"/logs"}
            >
              <IconToSolve iconName={"Info"} width={47} height={47} />
            </Link>
          </div>
        </Container>
      </Navbar>

      <ModalVersao show={showModalVersion} onHide={handleCloseModalVersion} />
      <ModalLogout show={showModalLogout} onHide={handleCloseModalLogout} />
    </>
  );
}

export default CustomNavbar;
